// First API Layer of reinsurance
import { init } from './init'

export const actions = Object.assign({}, init)
